jQuery(document).ready(function($) {
  //==========================//
  //Sticky Nav After Scrolling//
  //==========================//

  // Variables
  const $window = $(window);
  const $document = $(document);






  //AWS list
  var awsOpen = false;

    $document.on('click', '#aws-container', function() {
        if (!awsOpen) {
          $('#aws-list').slideDown(function() {
            $('#aws-close')
              .css("display", "flex")
              .hide()
              .fadeIn();
              awsOpen = true;
          });
        } else {
          $('#aws-close').hide();
          $('#aws-list').slideUp(function() {
            awsOpen = false;
          });
        }

    })

    $document.on('click', '#aws-close', function() {
      $('#aws-list').slideUp(function() {
        awsOpen = false;
      });

    })




})
